<template>
    <div class="scroll-loading" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0)" element-loading-text="加载中...">

    </div>
</template>

<script>
export default {
    data(){
        return {
            loading: true
        }
    }
}
</script>

<style lang="scss" scoped>
.scroll-loading{
    height: 100px;
    >>> {
        .el-loading-mask{
            z-index: 20;
        }
        .el-loading-spinner{
            display: flex;
            align-items: center;
            justify-content: center;
            circle{
                stroke: #969799;
                r: 10;
            }
            .el-loading-text{
                color: #969799;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/ScrollLoading/index.vue